// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__wKeh7","checked":"Switch_checked__DLrQw","slider":"Switch_slider__biNeT"};